import React from 'react';
import { ReactComponent as ThumbsUpIcon } from 'Assets/svg/thumbps-up-bg.svg';
import { HocPopupComponent } from 'Components/common/hocPopupComponent';
import Button from 'Components/common/Button';

const AutoEnrichmentInitiatedPopup = props => {
  const { togglePopup } = props;
  return (
    <HocPopupComponent
      customClassName="auto-enrichment-initiated"
      closeClick={() => togglePopup()}
    >
      <ThumbsUpIcon className="thumbps-up" />
      <div className="popup-title">Auto Enrichment Initiated</div>
      <div className="popup-description">
        Great work! Your CRM will now be auto enriched with Adapt&#39;s verified
        database.
      </div>
      <Button btnText="Ok &#128077;" click={togglePopup} />
    </HocPopupComponent>
  );
};

export default AutoEnrichmentInitiatedPopup;
